import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTooltipComponent } from './fi-tooltip.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { FiTooltipService } from '@fi-shared/fi-tooltip/fi-tooltip.service';
import { FiContentValidatorTooltipComponent } from '@fi-shared/fi-tooltip/fi-content-validator-tooltip/fi-content-validator-tooltip.component';
import { FiValidatorTooltipService } from '@fi-shared/fi-tooltip/fi-validator-tooltip.service';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, TooltipModule, FiAppTextSharedModule, MatIconModule],
    declarations: [FiTooltipComponent, FiContentValidatorTooltipComponent],
    providers: [FiTooltipService, FiValidatorTooltipService],
    exports: [FiTooltipComponent, FiContentValidatorTooltipComponent],
})
export class FiTooltipModule {}
